import { useEffect, useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Container,
  Fade,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import { Link } from "react-router-dom";
// import { AuthContext } from "../../context/authContext";

const Navbar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  // const { currentUser } = useContext(AuthContext);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 20;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrolled]);

  const handleMenu = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuItems = [
    { label: "Home", path: "/landing" },
    { label: "Blog", path: "/blog" },
    { label: "About", path: "/about-us" },
    { label: "Contact", path: "/contact" },
  ];

  return (
    <AppBar
      position="fixed"
      sx={{
        background: scrolled
          ? "linear-gradient(to right, #bb0000, #cc0000)"
          : "linear-gradient(to right, #bb0000, #cc0000)",
        boxShadow: scrolled ? "0 8px 32px rgba(187, 0, 0, 0.3)" : "none",
        transition: "all 0.4s ease",
      }}
    >
      <Container maxWidth="xl">
        <Toolbar
          sx={{
            py: 1,
            transition: "all 0.4s ease",
            height: scrolled ? "70px" : "90px",
          }}
        >
          <Fade in={true} timeout={2000}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexGrow: 1,
              }}
            >
              <Link
                to="/"
                style={{
                  textDecoration: "none",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Box
                  component="img"
                  src="https://res.cloudinary.com/duaz5kg1m/image/upload/v1739295008/logo1_8_ey3iob.png"
                  alt="VastuPlan Logo"
                  sx={{
                    width: 60,
                    height: 60,
                    mr: 2,
                    transition: "all 0.3s ease-in-out",
                    filter: "brightness(1.2)",
                  }}
                />
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 900,
                    color: "white",
                    textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
                  }}
                >
                  VastuPlan
                </Typography>
              </Link>
            </Box>
          </Fade>

          {isMobile ? (
            <>
              {/* <Button
                component={Link}
                to="/login"
                variant="outlined"
                sx={{
                  color: "white",
                  borderColor: "white",
                  mr: 2,
                  borderRadius: "24px",
                  textTransform: "capitalize",
                  "&:hover": {
                    borderColor: "white",
                    background: "rgba(255, 255, 255, 0.1)",
                  },
                }}
              >
                Login
              </Button> */}
              <IconButton
                color="inherit"
                aria-label="menu"
                onClick={handleMenu}
                sx={{
                  color: "white",
                  background: "rgba(255, 255, 255, 0.1)",
                  "&:hover": {
                    background: "rgba(255, 255, 255, 0.2)",
                    transform: "scale(1.1)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                <MenuIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                TransitionComponent={Fade}
                PaperProps={{
                  sx: {
                    background: "linear-gradient(to right, #bb0000, #cc0000)",
                    borderRadius: "12px",
                    mt: 2,
                    minWidth: 200,
                    boxShadow: "0 8px 32px rgba(187, 0, 0, 0.3)",
                  },
                }}
              >
                {menuItems.map((item) => (
                  <>
                    <MenuItem
                      key={item.label}
                      onClick={() => {
                        handleClose();
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }}
                      component={Link}
                      to={item.path}
                      sx={{
                        color: "white",
                        textDecoration: "none",
                        py: 1.5,
                        "&:hover": {
                          background: "rgba(255, 255, 255, 0.1)",
                        },
                      }}
                    >
                      {item.label}
                    </MenuItem>
                  </>
                ))}
                {/*<MenuItem
                  key={"login"}
                  sx={{
                    color: "white",
                    textDecoration: "none",
                    py: 1.5,
                    "&:hover": {
                      background: "rgba(255, 255, 255, 0.1)",
                    },
                  }}
                  component={Link}
                  to={currentUser ? "/properties" : "/login"}
                >
                  {currentUser ? "Dashboard" : "Login"}
                </MenuItem>*/}
              </Menu>
            </>
          ) : (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  background: scrolled
                    ? "rgba(255, 255, 255, 0.1)"
                    : "transparent",
                  borderRadius: "28px",
                  padding: "4px",
                  transition: "all 0.3s ease",
                  mr: 3,
                }}
              >
                {menuItems.map((item) => (
                  <Button
                    key={item.label}
                    component={Link}
                    to={item.path}
                    onClick={() => window.scrollTo(0, 0)}
                    sx={{
                      color: "white",
                      px: 2,
                      py: 1,
                      borderRadius: "24px",
                      fontSize: "0.95rem",
                      textTransform: "capitalize",
                      transition: "all 0.2s ease",
                      "&:hover": {
                        background: "rgba(255, 255, 255, 0.15)",
                        transform: "translateY(-1px)",
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                      },
                    }}
                  >
                    {item.label}
                  </Button>
                ))}
                {/*<Button
                  component={Link}
                  to={currentUser ? "/properties" : "/login"}
                  variant="outlined"
                  sx={{
                    color: "white",
                    borderColor: "rgba(255, 255, 255, 0.6)",
                    borderWidth: "2px",
                    borderRadius: "24px",
                    textTransform: "capitalize",
                    fontSize: "1rem",
                    fontWeight: 600,
                    px: 4,
                    py: 1,
                    position: "relative",
                    overflow: "hidden",
                    background: "rgba(255, 255, 255, 0.05)",
                    backdropFilter: "blur(5px)",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      background:
                        "linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.2), transparent)",
                      transform: "translateX(-100%)",
                      transition: "0.5s",
                    },
                    "&:hover": {
                      borderColor: "white",
                      background: "rgba(255, 255, 255, 0.1)",
                      transform: "translateY(-2px)",
                      boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)",
                      "&::before": {
                        transform: "translateX(100%)",
                      },
                    },
                    "&:active": {
                      transform: "translateY(1px)",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                    },
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  }}
                >
                  {currentUser ? "Dashboard" : "Login"}
                </Button>*/}
              </Box>
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;
